import { type FunctionComponent } from "react";
import { NavigationButton } from "../../atoms/NavigationButton";

type NavigationButtonsProps = {
  next: () => void;
  previous: () => void;
  primaryButtonText: string;
  secondaryButtonText: string;
  className?: string;
  isLoading?: boolean;
};

export const NavigationButtons: FunctionComponent<NavigationButtonsProps> = (
  props,
) => {
  return (
    <div className="my-5 flex w-full items-center justify-between font-bold">
      <NavigationButton
        type="secondary"
        text={props.secondaryButtonText}
        navigateToDestination={props.previous}
        icon={true}
        className={props.className}
        isLoading={props.isLoading}
      ></NavigationButton>
      <NavigationButton
        type="primary"
        text={props.primaryButtonText}
        navigateToDestination={props.next}
        icon={true}
        className="rounded-md bg-button-default"
        isLoading={props.isLoading}
      ></NavigationButton>
    </div>
  );
};
